import { inject, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { SkillsIdeateFlowData, SkillsIdeateStepDefinition } from '@core/tellent-skills-types';

import { SkillsIdeateFlowStepService } from './skills-ideate-flow-step.service';

@Injectable({ providedIn: 'root' })
export class SkillsIdeateFlowStateService {
  private readonly flowSteps = inject(SkillsIdeateFlowStepService).flowSteps;
  private readonly flowDataSubject = new BehaviorSubject<Partial<SkillsIdeateFlowData>>({});

  public readonly flowData$ = this.flowDataSubject.asObservable();

  private currentStepIndex = 0;

  public initializeFlow(): SkillsIdeateStepDefinition | null {
    this.currentStepIndex = 0;
    this.flowDataSubject.next({});
    return this.findNextValidStep();
  }

  public advanceFlow(
    stepData: Partial<SkillsIdeateFlowData> | null,
  ): SkillsIdeateStepDefinition | null {
    if (stepData) {
      this.flowDataSubject.next({ ...this.flowDataSubject.value, ...stepData });
    }
    this.currentStepIndex++;
    return this.findNextValidStep();
  }

  public goBack(): SkillsIdeateStepDefinition | null {
    const data = this.flowDataSubject.value;
    const prevStep =
      this.flowSteps
        .slice(0, this.currentStepIndex)
        .findLast(step => !step.canMatch || step.canMatch(data)) ?? null;
    if (prevStep) {
      this.currentStepIndex = this.flowSteps.indexOf(prevStep);
    }
    return prevStep;
  }

  private findNextValidStep(): SkillsIdeateStepDefinition | null {
    const data = this.flowDataSubject.value;
    while (this.currentStepIndex < this.flowSteps.length) {
      const stepDef = this.flowSteps[this.currentStepIndex];
      if (stepDef.canMatch && !stepDef.canMatch(data)) {
        this.currentStepIndex++;
        continue;
      }
      return stepDef;
    }
    return null;
  }
}
